import {RocketIcon, ArrowUpRightIcon, CommentIcon, ArrowSwitchIcon} from '@primer/octicons-react'
import {ActionMenu, ActionList} from '@primer/react'
import {useToggleFeaturePreview} from '../../../hooks/use-toggle-feature-preview'
import {useLayoutRouteData} from '../../../page-data/loaders/use-layout-route-data'
import {usePullRequestAnalytics} from '../../../hooks/use-pull-request-analytics'
import {NewLabel} from '@github-ui/lifecycle-labels/new'
import {AlphaLabel} from '@github-ui/lifecycle-labels/alpha'
import {isStaff} from '@github-ui/stats'
import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'

export function OverviewFeedback() {
  const {urls} = useLayoutRouteData()
  const toggleFeature = useToggleFeaturePreview('prs_overview_react')
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()
  const {isBrowser} = useRuntimeEnvironment()
  const staff = isBrowser && isStaff()

  const handleToggleOff = async () => {
    sendPullRequestAnalyticsEvent('overview.feature_toggle', 'OVERVIEW_FEATURE_TOGGLE', {enabled: false})
    await toggleFeature()
    window.location.href = `${urls.conversation}?overview=false`
  }

  return (
    <ActionMenu>
      <ActionMenu.Button
        variant="invisible"
        size="small"
        aria-label={staff ? 'Staff: Overview preview options' : 'Private preview: Overview preview options'}
      >
        {staff ? <NewLabel>Staff</NewLabel> : <AlphaLabel>Private preview</AlphaLabel>}
      </ActionMenu.Button>
      <ActionMenu.Overlay>
        <ActionList>
          <ActionList.LinkItem href="https://gh.io/pr-overview" target="_blank" rel="noopener noreferrer">
            <ActionList.LeadingVisual>
              <RocketIcon />
            </ActionList.LeadingVisual>
            What&apos;s new
            <ActionList.TrailingVisual>
              <ArrowUpRightIcon />
            </ActionList.TrailingVisual>
          </ActionList.LinkItem>
          <ActionList.LinkItem href="https://gh.io/pr-overview-feedback" target="_blank" rel="noopener noreferrer">
            <ActionList.LeadingVisual>
              <CommentIcon />
            </ActionList.LeadingVisual>
            Give feedback
            <ActionList.TrailingVisual>
              <ArrowUpRightIcon />
            </ActionList.TrailingVisual>
          </ActionList.LinkItem>
          <ActionList.Divider />
          <ActionList.Item onSelect={handleToggleOff}>
            <ActionList.LeadingVisual>
              <ArrowSwitchIcon />
            </ActionList.LeadingVisual>
            Turn off Overview preview
          </ActionList.Item>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
